import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import { getwebheader } from "@/request/sdir";
import weblogin1 from "@/components/weblogin.vue";
import register1 from "@/components/register.vue";
import setpassword from "@/components/setpassword.vue";
import { useRouter } from "vue-router";
import store from "@/store";
import { onMounted, reactive, ref, watch } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'webheader',
  setup(__props) {
    const clickEven = val => {
      showlogin.value = false;
      //router.push("/webpage/peoplepage");
      if (val.typeid == 2) {
        showregist.value = true;
      }
      if (val.typeid == 3) {
        showfindpassword.value = true;
      }
    };
    const clickEven2 = val => {
      showregist.value = false;
      if (val.typeid == 1) showlogin.value = true;
    };
    const clickEven1 = () => {
      showfindpassword.value = false;
    };
    const showfindpassword = ref(false);
    const showlogin = ref(false);
    const showregist = ref(false);
    const router = useRouter();
    const data = reactive({
      headermenu: []
    });
    const activeIndex2 = ref("/webpage/homepage");
    watch(() => store.state.mmenu, (newVal, oldVal) => {
      activeIndex2.value = newVal;
    });
    //const token = ref(localStorage.getItem("token"));
    const token = ref(localStorage.getItem("token"));
    function clickmenu(item) {
      token.value = localStorage.getItem("token");
      if (!token.value && (item.classcode == "/webpage/peoplepage" || item.classcode == "/webpage/orderpage")) {
        showlogin.value = true;
        /* ElMessageBox.alert("登录后方可进入个人空间!", {
        
          confirmButtonText: "确定",
        });
        router.push("/about");*/
      } else {
        store.commit("setmmenu", item.classcode);
        router.push(item.classcode);
      }
    }
    onMounted(() => {
      getwebheader("主导航菜单").then(res => {
        if (res.data.code == 401) {
          localStorage.clear();
          getwebheader("主导航菜单").then(res => {
            data.headermenu = res.data.data;
            data.headermenu.pop();
          });
        } else {
          data.headermenu = res.data.data;
          data.headermenu.pop();
        }
      });
    });
    watch(() => store.state.uuid, (newVal, oldVal) => {
      if (newVal == 2) {
        getwebheader("主导航菜单").then(res => {
          if (res.data.code == 401) {
            localStorage.clear();
            getwebheader("主导航菜单").then(res => {
              data.headermenu = res.data.data;
            });
          } else {
            data.headermenu = res.data.data;
          }
        });
      } else {
        if (oldVal == 2) data.headermenu.pop();
      }
      ;
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_menu, {
        "default-active": activeIndex2.value,
        mode: "horizontal",
        "background-color": "green",
        "text-color": "#fff",
        "active-text-color": "#afd04b"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.headermenu, item => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            onClick: $event => clickmenu(item),
            key: item.dataname,
            index: item.classcode
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.dataname), 1)]),
            _: 2
          }, 1032, ["onClick", "index"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active"]), _createVNode(_component_el_dialog, {
        width: "30%",
        "show-close": false,
        modelValue: showlogin.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showlogin.value = $event),
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(weblogin1, {
          onClickChild: clickEven
        })])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        width: "30%",
        "show-close": false,
        modelValue: showfindpassword.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showfindpassword.value = $event),
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(setpassword, {
          onClickChild: clickEven1
        })])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        width: "30%",
        "show-close": false,
        modelValue: showregist.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => showregist.value = $event),
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(register1, {
          onClickChild: clickEven2
        })])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});